import type { BuildingId } from '@/models/types';

export interface Synergy {
  source: BuildingId;
  target: BuildingId;
  bonusPerLevel: number;
}

export const SYNERGIES_ANCIENT: readonly Synergy[] = [
  { source: 'market', target: 'mine', bonusPerLevel: 0.10 },
  { source: 'mill', target: 'farm', bonusPerLevel: 0.10 },
  { source: 'temple', target: 'shrine', bonusPerLevel: 0.10 },
  { source: 'library', target: 'school', bonusPerLevel: 0.10 },
  { source: 'treasury', target: 'market', bonusPerLevel: 0.08 },
  { source: 'granary', target: 'mill', bonusPerLevel: 0.08 },
  { source: 'oracle', target: 'temple', bonusPerLevel: 0.08 },
  { source: 'academy', target: 'library', bonusPerLevel: 0.08 },
];

export const SYNERGY_CAP = 2.0;

export function calculateSynergyBonus(
  targetId: BuildingId,
  buildingLevels: Record<BuildingId, number>,
  synergies: readonly Synergy[],
): number {
  let bonus = 0;
  for (const s of synergies) {
    if (s.target === targetId) {
      bonus += (buildingLevels[s.source] ?? 0) * s.bonusPerLevel;
    }
  }
  return Math.min(bonus, SYNERGY_CAP);
}
